// extracted by mini-css-extract-plugin
export var avatarContainer = "_17-0";
export var avatarTypingWave = "_17-i";
export var gray = "_17-f";
export var green = "_17-c";
export var icon = "_17-9";
export var image = "_17-1";
export var lg = "_17-6";
export var md = "_17-5";
export var presenceDot = "_17-b";
export var red = "_17-d";
export var sm = "_17-4";
export var status = "_17-a";
export var typingDot = "_17-h";
export var typingPill = "_17-g";
export var xl = "_17-7";
export var xs = "_17-3";
export var xxl = "_17-8";
export var xxs = "_17-2";
export var yellow = "_17-e";